// File for logic corresponding to cta-membership component
import { Component } from 'js-component-framework';
import './index.scss';
import { isUserLoggedIn } from '@/js/utils/membership';

/**
 * Component for CTA Membership
 */
export default class CTAMembership extends Component {
  /**
   * Start the component
   */
  constructor(config) {
    super(config);
    this.init();
  }

  /**
   * Initialize
   */
  init() {
    if (!this.element) {
      return;
    }

    if (this.element.classList.contains('cta-membership--no-js')) {
      // Provides a way to improve UI loading experience.
      // See: `themes/cacm/client/src/components/cta/cta-membership/index.scss`
      this.element.classList.remove('cta-membership--no-js');
    }

    if (isUserLoggedIn()) {
      // Apply a class when a member is logged-in.
      this.element.classList.add('cta-membership--member-logged-in');
    }
  }
}
